<template>
  <PageDocumentList :page="page" />
</template>

<script setup lang="ts">
const route = useRoute();
const page = computed(() => route.params.documents);
</script>
